import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { MainWidgetWrapper } from 'views/common/components/Logical/MainWidgetWrapper';
import {
  DropdownFilter,
  DetailedRating,
  ImgBox,
} from 'views/common/components';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .VMDwidgetCont': {
    border: `1px solid ${theme.palette.grey[100]}`,
    [theme.breakpoints.up('lg')]: {
      maxWidth: theme.spacing(48.25),
      marginLeft: 'auto',
    },
  },
  '& .VMDadventure': {
    backgroundColor: theme.palette.grey.A000,
    padding: theme.spacing(2),
  },
  '& .VMDrating': {
    '& .RSitem': {
      maxWidth: theme.typography.pxToRem(108),
    },
  },
  '& .VMDYoutubContiner': {
    width: theme.spacing(86.125),
    height: theme.spacing(64.5),
    [theme.breakpoints.down('xl')]: {
      width: theme.spacing(60),
      height: theme.spacing(45),
    },
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      height: theme.spacing(52.5),
    },
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(26.625),
    },
  },
  '& .VMDVideoTitle': {
    [theme.breakpoints.up('lg')]: {
      fontSize: theme.spacing(2.5),
    },
  },
}));

export const StyledMainWidgetWrapper = styled(MainWidgetWrapper)(
  ({ theme }) => ({
    ' & .WTButton': {
      color: `${theme.palette.secondary.main}!important`,
      '& .WTTitle': {
        fontSize: theme.typography.pxToRem(16),
      },
      '& .WTMoreText': {
        fontSize: theme.typography.pxToRem(13),
      },
    },
  }),
);

export const StyledDropdownFilter = styled(DropdownFilter)(({ theme }) => ({
  '& .selectInput': {
    color: theme.palette.common.black,
    backgroundColor: 'transparent',
    textTransform: 'uppercase',
    fontWeight: '700',
    '&.Mui-focused': {
      backgroundColor: 'transparent',
      color: theme.palette.common.black,
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: '0',
  },
  '& .MuiSvgIcon-root': {
    fill: theme.palette.common.black,
  },
}));

export const StyledDetailedRating = styled(DetailedRating)(({ theme }) => ({
  '& .RSitem': {
    textAlign: 'center',
    position: 'relative',
    padding: theme.spacing(0, 1),
    '& .MuiSvgIcon-root': {
      width: theme.spacing(1.6),
      height: theme.spacing(1.6),
    },
  },
}));

export const StyledImgBox = styled(ImgBox)(({ theme }) => ({
  '&.VMDimg': {
    margin: 'auto',
    [theme.breakpoints.down('xl')]: {
      width: theme.spacing(65.5),
      height: theme.spacing(37.625),
    },
    [theme.breakpoints.down('lg')]: {
      width: theme.spacing(60.5),
      height: theme.spacing(34.75),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(36),
      height: theme.spacing(20.68),
    },
  },
}));

export default StyledBox;
